import { useDispatch } from "react-redux";
import useFetch from "../../hooks/useFetch";
import { getEmployeeSuccess, start } from "../../store/slices/TeamManagementSlice";


const EmployeeGoalDetail = ({ rowDataEmployee }) => {
    function formatDate(dateToString) {
        const date = new Date(dateToString);
        const day = date.getDate();
        const monthIndex = date.getMonth().toString();
        const year = date.getFullYear().toString();

        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month = monthNames[monthIndex];

        //let hours = date.getHours();
        //let minutes = date.getMinutes();

        // const ampm = hours >= 12 ? 'PM' : 'AM';
        //hours = hours % 12;
        // hours = hours ? hours : 12;
        // minutes = minutes < 10 ? '0' + minutes : minutes;

        const formattedDate = `${day} ${month} ${year}  `;
        return formattedDate;
    }

    const dispatch = useDispatch();
    const { data } = useFetch('employee')
    if (data.results && data.results.length > 0) {
        dispatch(getEmployeeSuccess(data));
    } else (
        dispatch(start())
    )

    return (
        <>
            {
                rowDataEmployee && rowDataEmployee.length > 0 ? (
                    rowDataEmployee.map((curData => {
                        const { id, name, status, created_at, updated_at, target, completed } = curData;

                        return (
                            <tr key={id}>
                                <td>{name}</td>
                                <td>{formatDate(created_at)}</td>
                                <td>{updated_at}</td>
                                <td>John Doe</td>
                                <td>{completed}%</td>
                                <td>{target}</td>
                                <td>{status ? "Active" : "Inactive"}</td>
                            </tr>
                        )
                    }))) : (
                    <span>No employee data available.</span>
                )
            }
        </>
    )
}

export default EmployeeGoalDetail;